/*eslint-disable*/
import React, { useState, useEffect } from 'react';
import { Dropdown } from 'semantic-ui-react'

const CustomerBranchDropdown = ({
    field: { name },
    form: { setFieldValue },
    branchData,
    getBranchSelected,
    salesOrderDetails,
    setVendorDetails,
    setBranchData,
    ...props
}) => {
    const [vendorData, setVendorData] = useState([])
    const [options, setOptions] = useState([])

    useEffect(() => {
            let options = []
            branchData.map((object, index) => {
                let branch = {}
                branch.key = object.billingPartyBranchId
                branch.text = object.billingPartyBranchName
                branch.value = object.billingPartyBranchCode
                return options[index] = branch
            })
            setOptions(options)

    }, [branchData])


    const handleOnChange = (e, data) => {
        setFieldValue(name, data.value);
        getBranchSelected && getBranchSelected(data.value, vendorData);
    }

    return (
        <Dropdown
            search
            selection
            onChange={(e, data) => handleOnChange(e, data)}
            options={options}
            clearable
            {...props}
        />
    )
}

export default CustomerBranchDropdown
